import { useImmutableContext, useImmutableContextProvider } from "@devowl-wp/react-utils";
const LIST_SERVICE_SYMBOL = Symbol();
const useListService = ()=>useImmutableContext(LIST_SERVICE_SYMBOL);
const useListServiceProvider = function() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
        args[_key] = arguments[_key];
    }
    return useImmutableContextProvider(LIST_SERVICE_SYMBOL, ...args);
};
export { useListService, useListServiceProvider };
